import { render, staticRenderFns } from "./MockLinksBtn.vue?vue&type=template&id=9b82ef62"
import script from "./MockLinksBtn.vue?vue&type=script&lang=js"
export * from "./MockLinksBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports